import * as yup from 'yup';
import postalCodes from 'postal-codes-js';
import {
  yupStringValidation,
  yupStringRequiredValidation,
  yupInternationalPhoneValidation,
  yupEmailRequiredValidation,
} from 'helpers/validation';

export const getAddressFormValidationSchema = (
  ifHaveStates: number | undefined,
  countryCode: string
) =>
  yup.object().shape({
    firstName: yupStringRequiredValidation('First name'),
    lastName: yupStringRequiredValidation('Last name'),
    country: yup
      .object({
        code: yup.string(),
        name: yup.string(),
      })
      .typeError('"Country" is a required field')
      .required('"Country" is a required field')
      .nullable()
      .test('Is empty?', '"Country" is a required field', (value) => {
        return !!value?.name;
      }),
    state: ifHaveStates
      ? yup
          .object({
            value: yup.string(),
            label: yup.string(),
          })
          .typeError('"State" is a required field')
          .required('"State" is a required field')
          .nullable()
          .test('Is empty?', '"State" is a required field', (value) => {
            return !!value?.value;
          })
      : yupStringValidation('State'),
    stateName: yupStringValidation('State'),
    city: yupStringRequiredValidation('City'),
    zipCode: yup
      .string()
      .test('postalCodeValidation', 'Zip code is invalid', function (value) {
        const { path, createError } = this;
        const isValid =
          !countryCode ||
          postalCodes.validate(countryCode, value || '') === true;
        return isValid || createError({ path });
      })
      .required('"Zip" is a required field'),
    addressLine1: yupStringRequiredValidation('Address line 1'),
    addressLine2: yupStringValidation('Address line 2'),
    phoneNumberE164: yupInternationalPhoneValidation(),
    email: yupEmailRequiredValidation('"Email" is a required field'),
    isDefault: yup.boolean(),
  });
